<gstar-grid
  dataIdKey="id"
  [source]="source.items"
  [totalCount]="source.total"
  [lazy]="true"
  [drawerSetting]="drawerSetting"
  [searchSetting]="searchSetting"
  [actionButtons]="actionButtons"
  [headers]="headers"
  [query]="query"
  (queryChange)="queryHandler($event)"
  [noDataFilteredMessage]="
    'admin.dashboard.notFoundRecordsMessage' | translate
  " />
